import { Component, h } from 'preact'
import Header from '../header'
import { EmailInfo } from './overview'
import CodeMirror from '../codemirror'
import InputGroup from '../ui-components/InputGroup'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'

interface State {
  emailSubject: string,
  emailBody: string,
  message: string,
  messageType: null | string,
  isPreviewActive: boolean
}

class EmailEdit extends Component<EmailInfo, State> {
  constructor (props: EmailInfo) {
    super(props)
    this.state = {
      emailSubject: props.subjectTranslation,
      emailBody: props.bodyTranslation,
      message: '',
      messageType: null,
      isPreviewActive: false
    }
    this.onSave = this.onSave.bind(this)
  }

  async onSave () {
    this.setState({ messageType: null })
    let subjectResponse
    let bodyResponse

    if (this.state.emailSubject !== this.props.subjectTranslation) {
      subjectResponse = Axios.post('/configuration/email-template/save', {
        category: this.props.subjectModule,
        message: this.props.subjectKey,
        translation: this.state.emailSubject
      })
    }
    if (this.state.emailBody !== this.props.bodyTranslation) {
      bodyResponse = Axios.post('/configuration/email-template/save', {
        category: this.props.bodyModule,
        message: this.props.bodyKey,
        translation: this.state.emailBody
      })
    }

    try {
      await Promise.all([subjectResponse, bodyResponse])
      this.setState({ messageType: 'success', message: 'Email is saved successfully!' }, () => {
        window.setTimeout(() => window.location.assign('/configuration/email-template'), 3000)
      })
    } catch (err) {
      this.setState({ messageType: 'error', message: 'Something went wrong' })
    }
  }

  render ({ type, title, subjectModule, subjectKey, bodyModule, bodyKey, description }: EmailInfo,
    { emailSubject, emailBody, messageType, message, isPreviewActive }: State) {
    return (
      <div className='email-template-edit-page'>
        <Header
          title={`Edit '${title}' email`}
          hasBreadcrumb
          breadcrumbText='Back to email templates overview'
          breadcrumbLink='/configuration/email-template'
          saveCallback={this.onSave}
        />
        {
          messageType ? <AlertComponent messageType={messageType} message={message} sticky renderHTML isVisibleFor={3000} /> : null
        }
        <div>
          <div className='email-template-description'> { description } </div>
          <InputGroup
            title='Subject'
            type='text'
            onChange={(e: {target: HTMLInputElement}) => { this.setState({ emailSubject: e.target.value }) }}
            value={emailSubject} />

          <div className='email-body-template-wrapper'>
            <label>Body</label>
            <div className='email-template_edit-preview--buttons'>
              <span className={`email-template_edit-btn ${!isPreviewActive ? 'active' : ''}`} onClick={() => {this.setState({ isPreviewActive: false }) }}>Edit HTML</span>
              <span className={`email-template_preview-btn ${isPreviewActive ? 'active' : ''}`} onClick={() => {this.setState({ isPreviewActive: true }) }}>Preview</span>
            </div>
            {
              !isPreviewActive ? (
                <div className='email-template'>
                  <CodeMirror
                    defaultValue={emailBody}
                    onChange={(html: string) => { this.setState({ emailBody: html }) }}
                    options={{
                      lineNumbers: true,
                      mode: 'text/html',
                      selectionPointer: true,
                      autoRefresh: true,
                      autoResize: true
                    }}
                  />
                </div>
              ) : (
                <div className='email-template-preview'>
                  <div className='email-template-preview-placeholder' dangerouslySetInnerHTML={{ __html: emailBody }} />
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

export default EmailEdit
